import {GlobalFilterGroupedSelectionType, GlobalFilterSelectType} from "@global/global-elements/global-filter-select/GlobalFilterSelectType";

export type GlobalFilterType = GlobalFilterGroupedSelectionType | GlobalFilterSelectType

export enum GlobalFilterTypesType {
    SELECT= 'select',
    GROUPED_SELECTION = 'groupedselection',
    SELECTION_GROUP = 'selectiongroup',
    UNDEFINED = 'undefined'
}

export type GlobalFilterOptionType = {
    key: string,
    title: string,
    value: string,
    selected: boolean,
    disabled: boolean,
    parentFilter?: string, // The source filter name for nested options
    style?: "group" | "nested"
}

export type GlobalFilterChangeEvent = {
    filterName: string,
    optionName: string
}

export type GlobalFilterRemoveEvent = {
    filterName: string
}
